import { ApiNames, ApiProxy, ApiRequest, HttpMethod } from '@lib/api/apiProxy';

export class UserTutorialCommandApi {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.UserTutorial;

  public static upsertUserTutorial(
    upsertUserTutorial: UpsertUserTutorial
  ): Promise<UserTutorial> {
    return this.apiProxy.execute(
      new ApiRequest(this.apiName, `/`, HttpMethod.POST, upsertUserTutorial)
    );
  }
}
